<template>
  <div class="row mb-4 gy-3">
    <div class="col-md-6">
      <label for="priceNameFilter" class="form-label">Product Names</label>
      <MultiSelectComponent
        :options="productOptions"
        :modelValue="filters.names"
        @update:modelValue="updateFilter('names', $event)"
        placeholder="Select products to compare"
      />
      <small class="text-muted">
        Select multiple products to compare in charts. Source shown in
        parenthesis.
      </small>
    </div>
    <div class="col-md-6">
      <label for="vintageFilter" class="form-label">Vintages</label>
      <MultiSelectComponent
        :options="vintageOptions"
        :modelValue="chartFilters.vintages"
        @update:modelValue="updateChartFilter('vintages', $event)"
        placeholder="Select vintages to display"
      />
      <small class="text-muted">
        Select multiple vintages to compare. Controls both table and chart.
      </small>
    </div>
  </div>
</template>

<script setup lang="ts">
import MultiSelectComponent from "@/components/common/MultiSelectComponent.vue";
import { computed } from "vue";

interface PriceFilters {
  names: string[];
}

interface ChartFilters {
  vintages: string[];
}

interface AvailableName {
  name: string;
  source: string;
}

const props = defineProps<{
  availableVintages: string[];
  availableNames: AvailableName[];
}>();

const filters = defineModel<PriceFilters>("filters", { required: true });
const chartFilters = defineModel<ChartFilters>("chartFilters", {
  required: true,
});

const productOptions = computed(() => {
  return props.availableNames.map((item) => ({
    label: `${item.name} (${item.source})`,
    value: `${item.name}|||${item.source}`,
  }));
});

const vintageOptions = computed(() => {
  return props.availableVintages.map((year) => ({
    label: year.toString(),
    value: year,
  }));
});

const updateFilter = (key: keyof PriceFilters, value: any) => {
  filters.value = { ...filters.value, [key]: value };
};

const updateChartFilter = (key: keyof ChartFilters, value: any) => {
  chartFilters.value = { ...chartFilters.value, [key]: value };
};
</script>
